import { isNil } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Item } from './item.jsx';
import type { SectionProps } from './types.js';
import { Categories } from '#~/hot-keys/index.js';

/** `<Section>` component. */
export const Section = ({
  category,
  className,
  formula,
  hotKeys,
  onCommit,
  style,
  ...props
}: SectionProps): ReactElement => {
  const { actions } = Categories[category];

  return (
    <div
      className={twMerge(
        'grid grid-flow-col grid-cols-2 gap-x-40 border-t border-base-100',
        className
      )}
      style={{ ...style, gridTemplateRows: `repeat(${Math.ceil(actions.length / 2)},1fr)` }}
      {...props}
    >
      {actions.map((action) => {
        const combo = hotKeys[action];

        if (isNil(combo)) {
          return null;
        }

        // Be very careful w/ memoization here!
        return (
          <Item action={action} combo={combo} formula={formula} key={action} onCommit={onCommit} />
        );
      })}
    </div>
  );
};
